import Image from 'next/image';

import { useGetSrMatchesQuery, useGetSupplierRequestsQuery } from '../../api';

export const Answers = ({
  requestId,
  matchId,
}: {
  requestId: string;
  matchId: string;
}) => {
  const { data: supplierRequestMatches } = useGetSrMatchesQuery(requestId);
  const { data: supplierRequests } = useGetSupplierRequestsQuery();
  const supplierRequest = supplierRequests?.find(
    (supplierRequest: any) => supplierRequest.requestId === requestId
  );
  const matchedSrm = supplierRequestMatches?.find(
    (supplierRequestMatch: any) => supplierRequestMatch.matchId === matchId
  );
  // const questionAnswers = Object.entries(supplierRequest?.questions || {}).map(
  //   ([questionId]) => {
  //     return {
  //       question: supplierRequest?.questions?.[questionId] || '',
  //       answer: matchedSrm?.answers?.[questionId] || '',
  //     };
  //   }
  // );

  const questionAnswers: any[] = [];

  return (
    <div className="p-4">
      {questionAnswers.map(({ question, answer }, index) => (
        <div key={index} className="space-y-4">
          <div className="flex justify-start items-end gap-2">
            <Image
              src="/icons/avatar-cvs.svg"
              width={40}
              height={40}
              alt="Avatar"
            />
            <span className="bg-primary-100 rounded-2xl rounded-bl-md p-4">
              {question}
            </span>
          </div>
          <div className="flex justify-end items-end gap-2">
            <span className="bg-primary-100 rounded-2xl rounded-bl-md p-4">
              {answer}
            </span>
            <Image
              src="/icons/avatar-cvs.svg"
              width={40}
              height={40}
              alt="Avatar"
            />
          </div>
        </div>
      ))}
    </div>
  );
};
